<app-top-bar></app-top-bar>
<div class="mt-2">
<h2 class="bg-danger text-dark text-center fs-3 mb-0">Movie Details</h2>
    <table class="top-0 bg-secondary text-light">
        <tr>
            <th>
                Sno
            </th>
            <th>
                Title
            </th>
            <th>
                ImageSource
            </th>
            <th>
                Description
            </th>
            <th>
                Action
            </th>
        </tr>
        <tr >
        <td colspan="5" class="fs-2 text-warning text-center">TamilMovies</td>
        </tr>
        <tr *ngFor="let Trend of Trending; let i = index;">
        <td>{{i+1}}</td>
        <td>{{Trend.title}}</td>
        <td><img src="{{Trend.imgSrc}}" width="50px" height="50px"></td>
        <td>{{Trend.description}}</td>
        <td>
            <button class="btn btn-dark" (click)="onEdit(Trend)">Edit</button>
        </td>
        </tr>
    </table>
</div>